import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { getLegacyDebugRoute } from 'lib/router'

const UUIDV4_REGEXP =
  /[a-f0-9]{8}-?[a-f0-9]{4}-?4[a-f0-9]{3}-?[89ab][a-f0-9]{3}-?[a-f0-9]{12}/i

export function useMessageSearch() {
  const navigate = useNavigate()

  const handleChange = useCallback(
    (value: string) => {
      value = value.trim()

      if (!UUIDV4_REGEXP.test(value)) {
        return
      }

      navigate(getLegacyDebugRoute(value))
    },
    [navigate],
  )

  return {
    onChange: handleChange,
  }
}
